import React from "react";
var __jsx = React.createElement;
import { Toaster } from "sonner";
import { createPortal } from "react-dom";
import { Icon } from "@syarahtech/ui";
import useDirection from "@hooks/useDirection";
var SonnerToast = function SonnerToast() {
  var direction = useDirection();
  if (typeof document === 'undefined' || __IS_SSR__) {
    return null;
  }
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(Toaster, {
    toastOptions: {
      duration: 5000,
      closeButton: false,
      classNames: {
        success: "bg-success",
        error: "bg-danger",
        warning: "bg-warning",
        info: "bg-primary",
        title: "text-white text-start font-regular text-sm ar:font-plex-arabic en:font-inter ar:text-right",
        toast: "w-full flex items-center gap-2 p-3 rounded-lg shadow-lg",
        icon: "items-baseline grow-1 w-5 h-5 m-0 self-baseline font-regular",
        description: "text-white text-start text-xs ar:font-plex-arabic en:font-inter ar:text-right",
        closeButton: "text-neutral-70 hover:text-neutral-80 bg-white shadow transition-colors duration-200 ease-in-out ar:left-[-16px] ar:right-[unset] en:left-[unset] en:right-[-16px]",
        actionButton: "text-white my-auto text-sm en:ml-auto ar:mr-auto px-2 py-1 border border-solid border-white font-regular text-sm rounded-md hover:border-transparent transition-colors duration-200 ease-in-out ar-text:font-plex-arabic en-text:font-inter"
      }
    },
    dir: direction,
    style: {
      zIndex: 99999999,
      pointerEvents: 'auto'
    },
    icons: {
      success: /*#__PURE__*/React.createElement(Icon, {
        width: 5,
        height: 5,
        variant: "white",
        icon: "material-symbols--check-circle-rounded"
      }),
      error: /*#__PURE__*/React.createElement(Icon, {
        width: 5,
        height: 5,
        variant: "white",
        icon: "material-symbols--dangerous-outline-rounded"
      }),
      info: /*#__PURE__*/React.createElement(Icon, {
        width: 5,
        height: 5,
        variant: "white",
        icon: "material-symbols--error-rounded"
      }),
      warning: /*#__PURE__*/React.createElement(Icon, {
        width: 5,
        height: 5,
        variant: "white",
        icon: "material-symbols--warning-rounded"
      })
    }
  }), document.body);
};
export default SonnerToast;